import OpacityIcon from '@material-ui/icons/Opacity';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

const BILL_STATE = {
    canceled: 'canceled',
    paid: 'paid',
    unpaid: 'unpaid'
};

const EXTRA_OPTIONS = [
    { key: 'water', label: 'Eau', Icon: OpacityIcon, priceField: 'water_price' },
    {
        key: 'electricity',
        label: 'Électricité',
        Icon: FlashOnIcon,
        priceField: 'electricity_price'
    },
    { key: 'truck', label: 'Camion', Icon: LocalShippingIcon, priceField: 'truck_price' }
];

export { BILL_STATE, EXTRA_OPTIONS };
